export default "__VITE_ASSET__e5a42187__"